import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { ValList } from '@/common/val/ValList';
import { AbvLbeItemList } from './AbvLbeItemList';
import { AbvPbmRateList } from './pbmRate/AbvPbmRateList';

export const AbvLbeDetail = () => {

  const { entityObj } = useEntityMgr();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'lbeItemTab', label: 'LBE Items', content: <AbvLbeItemList lbeId={entityObj.id}/> },
    { id: 'pbmRateTab', label: 'PBM Rates', content: <AbvPbmRateList lbeId={entityObj.id}/> },
    { id: 'valTab', label: 'Validations', content: <ValList parentEntity="LBE" parentEntityId={entityObj.id} />}
  ]

  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}